<template>
  <h3
    class="data-heading"
    :class="{'data-heading--spaced': spaced}"
  >
    <slot>{{ heading }}</slot>
  </h3>
</template>

<script>
  export default {
    name: 'DataHeading',
    props: {
      heading: {
        type: String,
        default: undefined

      },
      spaced: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .data-heading {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.3;

    &--spaced {
      margin-top: 26px;
    }
  }
</style>
